"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContextService = void 0;
class UserContextService {
    constructor(userContextOptions) {
        this._editorInfo = null;
        this._accountId = null;
        this._id = null;
        this._firstName = null;
        this._lastName = null;
        this._fullName = null;
        this._email = null;
        this._phone = null;
        this._avatarUrl = null;
        this._language = null;
        this._organization = null;
        if (!userContextOptions.tokenProvider) {
            throw new Error('TokenProvider is not defined');
        }
        this._tokenProvider = userContextOptions.tokenProvider;
    }
    get accountId() {
        if (this._accountId) {
            return this._accountId;
        }
        this._accountId = this.setupAccountId();
        return this._accountId;
    }
    get id() {
        if (this._id) {
            return this._id;
        }
        this._id = this.setupEditorId();
        return this._id;
    }
    get firstName() {
        if (this._firstName) {
            return this._firstName;
        }
        this._firstName = this.setupFirstName();
        return this._firstName;
    }
    get lastName() {
        if (this._lastName) {
            return this._lastName;
        }
        this._lastName = this.setupLastName();
        return this._lastName;
    }
    get fullName() {
        if (this._fullName) {
            return this._fullName;
        }
        this._fullName = this.setupFullName();
        return this._fullName;
    }
    get email() {
        if (this._email) {
            return this._email;
        }
        this._email = this.setupEmail();
        return this._email;
    }
    get phone() {
        if (this._phone) {
            return this._phone;
        }
        this._phone = this.setupPhone();
        return this._phone;
    }
    get avatarUrl() {
        if (this._avatarUrl) {
            return this._avatarUrl;
        }
        this._avatarUrl = this.setupAvatarUrl();
        return this._avatarUrl;
    }
    get language() {
        if (this._language) {
            return this._language;
        }
        this._language = this.setupLanguage();
        return this._language;
    }
    get organization() {
        if (this._organization) {
            return this._organization;
        }
        this._organization = this.setupOrganization();
        return this._organization;
    }
    async setupAccountId() {
        const authInfo = await this.getEditorInfo();
        return authInfo.accountId;
    }
    async setupFirstName() {
        const authInfo = await this.getEditorInfo();
        return authInfo.firstName;
    }
    async setupLastName() {
        const authInfo = await this.getEditorInfo();
        return authInfo.lastName;
    }
    async setupFullName() {
        const authInfo = await this.getEditorInfo();
        return `${authInfo.firstName} ${authInfo.lastName}`;
    }
    async setupEmail() {
        const authInfo = await this.getEditorInfo();
        return authInfo.email;
    }
    async setupPhone() {
        const authInfo = await this.getEditorInfo();
        return authInfo.phone || '';
    }
    async setupAvatarUrl() {
        const authInfo = await this.getEditorInfo();
        return authInfo.avatarUrl || '';
    }
    async setupEditorId() {
        const editorInfo = await this.getEditorInfo();
        return editorInfo.id;
    }
    async setupLanguage() {
        const editorInfo = await this.getEditorInfo();
        return editorInfo.language || 'en';
    }
    async setupOrganization() {
        const editorInfo = await this.getEditorInfo();
        return editorInfo.organization || null;
    }
    async getEditorInfo() {
        if (this._editorInfo) {
            return this._editorInfo;
        }
        this._editorInfo = this.setupEditorInfo();
        return this._editorInfo;
    }
    async setupEditorInfo() {
        if (!window.editorServiceUrl) {
            throw new Error('EditorServiceUrl is not defined');
        }
        const token = await this._tokenProvider.getToken();
        if (!token) {
            throw new Error('Token is not defined');
        }
        const authUrl = `${window.editorServiceUrl}/api/v1/user/user-context`;
        const editorInfoResponse = await fetch(authUrl, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` }
        });
        return (await editorInfoResponse.json());
    }
}
exports.UserContextService = UserContextService;
